import React, { useState } from 'react';
import { apiService } from '../services/api';

const Login = ({ onLoginSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    try {
      console.log('=== LOGIN START ===');
      console.log('Cookies vor Login:', document.cookie);
      
      // Verwende den gleichen API-Service wie der Rest der App
      const response = await apiService.login(username, password);
      console.log('Login Response Data:', response);

      if (response.success) {
        console.log('=== LOGIN SUCCESS ===');
        console.log('Login erfolgreich:', response);
        console.log('Cookies nach Login:', document.cookie);
        
        // Kurze Pause für Session-Speicherung
        await new Promise(resolve => setTimeout(resolve, 100));
        
        onLoginSuccess();
      } else {
        console.error('Login fehlgeschlagen:', response);
        setError(response.error || 'Login fehlgeschlagen');
      }
    } catch (error) {
      console.error('Login-Fehler:', error);
      setError(`Fehler beim Login: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-bg-1 flex items-center justify-center p-4">
      <div className="bg-accent-3 rounded-lg shadow-md max-w-md w-full border border-accent-2">
        <div className="text-center mb-8 p-6">
          <img 
            src="/wachtel_icon.png" 
            alt="Wachtel Icon" 
            className="w-16 h-16 mx-auto mb-4 object-contain"
          />
          <h2 className="text-2xl font-heading font-bold text-bg-1 mb-2">Wachtel Stammtisch</h2>
          <p className="text-bg-1/70 text-base">Deine digitale Bierkasse</p>
        </div>
        
        <form onSubmit={handleSubmit} className="space-y-6 px-6 pb-6">
          <div>
            <label htmlFor="username" className="block text-sm font-semibold text-bg-1 mb-2">
              Benutzername
            </label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              className="w-full px-4 py-3 border-2 border-accent-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-accent-1 focus:border-accent-1 transition-all duration-200 bg-bg-2 text-text-strong"
              placeholder="Dein Benutzername"
            />
          </div>
          
          <div>
            <label htmlFor="password" className="block text-sm font-semibold text-bg-1 mb-2">
              Passwort
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full px-4 py-3 border-2 border-accent-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-accent-1 focus:border-accent-1 transition-all duration-200 bg-bg-2 text-text-strong"
              placeholder="Dein Passwort"
            />
          </div>
          
          {error && (
            <div className="bg-status-error/10 border-2 border-status-error/20 rounded-lg p-4">
              <p className="text-status-error text-sm font-medium">{error}</p>
            </div>
          )}
          
          <button
            type="submit"
            disabled={isLoading}
            className="btn-primary w-full disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLoading ? (
              <div className="flex items-center justify-center">
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                Anmeldung läuft...
              </div>
            ) : (
              'Anmelden'
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
